import { gql } from '@apollo/client';

const QUERY_QUIZ = gql`
  query AllAvailableQuizz {
    availableQuiz {
      id
      name
      debut
      fin
      quizlet
      desc
      isAnsweredByUser
    }
  }
`;

export default QUERY_QUIZ;
